import type { ReactElement } from 'react';
import styled, { css } from 'styled-components';

import { device, hexToRGB } from '@/styles/helpers';

export interface ScButtonProps {
  main?: boolean;
  secondary?: boolean;
  big?: boolean;
  small?: boolean;
  icon?: ReactElement;
}

export const ScButton = styled.button<ScButtonProps>`
  width: 100%;
  border: none;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.01em;
  text-align: center;
  text-transform: uppercase;
  border-radius: ${({ theme }) => theme.borderRadius1};

  ${({ icon }) =>
    icon &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
    `}

  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  &:active {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.2;
  }

  ${({ main }) =>
    main &&
    css`
      background: ${({ theme }) => theme.color25};
      color: ${({ theme }) => theme.white};

      &:not(:disabled):hover {
        background: ${({ theme }) => theme.color27};

        @media (${device.mobile}) {
          background: ${({ theme }) => theme.color25};
        }
      }
    `}

  ${({ secondary }) =>
    secondary &&
    css`
      background: ${({ theme }) => hexToRGB(theme.white, 0.2)};
      color: ${({ theme }) => theme.white};

      &:not(:disabled):hover {
        background: ${({ theme }) => hexToRGB(theme.white, 0.6)};

        @media (${device.mobile}) {
          background: ${({ theme }) => hexToRGB(theme.white, 0.2)};
        }
      }
    `}

  ${({ big }) =>
    big &&
    css`
      height: 48px;
      padding: 0 8px;
    `}

  ${({ small }) =>
    small &&
    css`
      height: 40px;
      padding: 0 8px;
    `}
`;
